<template>
  <div class="coming-soon-cell thumb autoplay-cell instant-player-cell">
    <div class="thumb-image">
      <a
        href="javascript:void(0)"
        aria-labelledby="autoplay-cell-title-1-1 autoplay-cell-title-1-2"
        class="click-area"
        @click.prevent="onClickDetail"
      >
        <div class="picture-area">
          <WebpImage
            :image-info="{
              imageUrl: thumbnail,
              width: thumbnailInfo.width,
              height: thumbnailInfo.height,
              alt: altTitle,
              className: 'thumb-img',
            }"
          />
        </div>
        <ul class="badge-list">
          <li class="left-top-area">
            <TopTagList v-if="hasTopTagList" :top-tag-list="topTagList" />
          </li>
          <li class="right-top-area">
            <CommonTagList
              v-if="hasBrandTagList"
              :badge-list="brandTagList"
              :type="'brand'"
            />
          </li>
        </ul>
        <AgeLimits class="tag-age" :target-age="targetAge" :age-tag="ageTag" />
        <div class="sub-title">
          <TitleList
            v-if="hasTitleList"
            :title-list="titleList"
            :cell-type="'landscape'"
            @click="onClickDetail"
          />
        </div>
      </a>
      <div class="heart-button">
        <BtnZzimWithEvent
          :is-on="zzim"
          :icon-only="true"
          :event-list="eventList"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
  import { computed } from 'vue'
  import WebpImage from '@/components/image/WebpImage.vue'
  import CommonTagList from '@/components/cell-fragment/CommonTagList.vue'
  import TopTagList from '@/components/cell-fragment/TopTagList.vue'
  import { useCell } from '@/common/use/useCell'
  import BtnZzimWithEvent from '@/components/button/BtnZzimWithEvent.vue'
  import AgeLimits from '@/components/model/AgeLimits.vue'
  import TitleList from '@/components/cell-fragment/TitleList.vue'

  const props = defineProps({
    cellInfo: {
      type: Object,
      default: null,
    },
    thumbnailInfo: {
      type: Object,
      default: null,
    },
  })

  const {
    altTitle,
    thumbnail,
    targetAge,
    ageTag,
    titleList,
    brandTagList,
    topTagList,
    hasTopTagList,
    hasBrandTagList,
    hasTitleList,
    eventList,
    goDetail,
  } = useCell(props.cellInfo)

  const zzim = computed(() => props.cellInfo?.iszzim ?? 'n')

  const onClickDetail = () => {
    goDetail(props.cellInfo)
  }
</script>
<style scoped lang="scss">
  .list-view {
    .coming-soon-cell {
      .thumb-image {
        overflow: inherit;
      }
    }
  }

  .coming-soon-cell {
    .thumb-image {
      overflow: inherit;
      .click-area {
        .picture-area {
          overflow: hidden;
          border-radius: 12px;
          height: 229px;
        }
        .badge-list {
          overflow: hidden;
          border-radius: 12px;
          z-index: 1;
        }
      }
      .heart-button {
        position: absolute;
        bottom: calc(-34px - 17px);
        right: 12px;
      }
    }
  }
</style>
